import { IconFinanceArrowBoldUp16, IconFinanceArrowBoldDown16 } from '@cian/ui-kit-design-tokens/icons';
import { ReactElement } from 'react';
import {
  EDemandDiffTrand,
  ESupplyDiffTrand,
} from 'shared/repositories/valuation-offer-history/entities/market_trand/GetSupplyDemandResponseSchema';

interface IUseGetSupplyDemandDiffParams {
  demandDiff: string;
  demandDiffTrand: EDemandDiffTrand;
  supplyDiffTrand: ESupplyDiffTrand;
  supplyDiff: string;
}

type DiffData = {
  text: string;
  icon: ReactElement<any> | null;
};

interface IUseGetSupplyDemandDiffReturnData {
  demandDiffData: DiffData;
  supplyDiffData: DiffData;
}
export function useGetSupplyDemandDiff({
  demandDiff,
  demandDiffTrand,
  supplyDiff,
  supplyDiffTrand,
}: IUseGetSupplyDemandDiffParams): IUseGetSupplyDemandDiffReturnData {
  let demandDiffData: DiffData = {
    text: '',
    icon: null,
  };

  switch (demandDiffTrand) {
    case EDemandDiffTrand.Increase:
      demandDiffData = {
        text: `+${demandDiff}`,
        icon: <IconFinanceArrowBoldUp16 color="icon-main-default" />,
      };
      break;
    case EDemandDiffTrand.Decrease:
      demandDiffData = {
        text: `−${demandDiff}`,
        icon: <IconFinanceArrowBoldDown16 color="icon-main-default" />,
      };
      break;
    case EDemandDiffTrand.NoChange:
      demandDiffData = {
        text: '0%',
        icon: null,
      };
      break;
  }

  let supplyDiffData: DiffData = {
    text: '',
    icon: null,
  };

  switch (supplyDiffTrand) {
    case ESupplyDiffTrand.Increase:
      supplyDiffData = {
        text: `+${supplyDiff}`,
        icon: <IconFinanceArrowBoldUp16 color="icon-main-default" />,
      };
      break;
    case ESupplyDiffTrand.Decrease:
      supplyDiffData = {
        text: `−${supplyDiff}`,
        icon: <IconFinanceArrowBoldDown16 color="icon-main-default" />,
      };
      break;
    case ESupplyDiffTrand.NoChange:
      supplyDiffData = {
        text: '0%',
        icon: null,
      };
      break;
  }

  return { demandDiffData, supplyDiffData };
}
